import React from 'react';
import { Box } from '@mui/material';
import CincopaDefaultGallery from '@/components/gallery/CincopaDefaultGallery';
import useAppSelector from '@/hooks/useAppSelector';
import {
  getMyCompanyDetails,
  getUserSelector,
} from '@/redux/selectors/userSelectors';

const Gallery: React.FC = () => {
  const user = useAppSelector(getUserSelector);
  const myCompanyDetails = useAppSelector(getMyCompanyDetails);
  const company = myCompanyDetails || user?.companies?.[0];

  return (
    <Box
      padding="20px"
      sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <CincopaDefaultGallery fid={ company?.cincopaFid } />
    </Box>
  );
};

export default Gallery;

